import { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Outlet } from "react-router";
import { useTranslation } from "react-i18next";

import useAppSelector from "../../hooks/useAppSelector";
import { setProfileImage } from "../../helper/imagePaths";

import styles from "./Profile.module.scss";

const navItems = [
  { path: "/profile/upcoming", labelKey: "Upcoming" },
  { path: "/profile/attended", labelKey: "Attended" },
  { path: "/profile/saved-places", labelKey: "SavedPlaces" },
];

const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useAppSelector((state) => state.userProfileSlice);

  useEffect(() => {
    if (location.pathname === "/profile") {
      navigate("/profile/saved-places");
    }
  }, [location.pathname, navigate]);

  return (
    <div className="container">
      <div className={styles.container}>
        <aside className={styles.menuWrapperContainer}>
          <div className={styles.menuWrapper}>
            <div className={styles.wrapperInfoInside}>
              <div className={styles.imageWrapper}>
                <div
                  className={styles.profileImage}
                  style={{ backgroundImage: `url(${setProfileImage(user)})` }}
                />
              </div>

              {user && <h3 className={styles.username}>{`${user.firstname} ${user.lastname}`}</h3>}

              <div className={styles.row}>
                <p className={styles.link}>{t("RemainingCredits")}:</p>
                <div className={styles.row}>
                  <p className={styles.count}>47</p>
                  <p className={styles.getMore}>{t("GetMore")}</p>
                </div>
              </div>

              <div className={styles.row}>
                <p className={styles.link}>{t("NextCycleBegins")}:</p>
                <div className={styles.row}>
                  <p className={styles.count}>12/25</p>
                </div>
              </div>
            </div>

            <ul className={styles.listNavbar}>
              {navItems.map(({ path, labelKey }) => (
                <li key={path}>
                  <NavLink
                    to={path}
                    className={({ isActive }) =>
                      isActive ? `${styles.link} ${styles.active}` : styles.link
                    }
                  >
                    {t(labelKey)}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </aside>

        <section className={styles.outlet}>
          <Outlet />
        </section>
      </div>
    </div>
  );
};

export default Profile;
